import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Advertorial } from './pages/Advertorial';
import { ProductDetail } from './pages/ProductDetail';
import { Checkout } from './pages/Checkout';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/" element={<Advertorial data-id="element-4" />} data-id="element-3" />
        <Route path="/adv" element={<Advertorial data-id="element-6" />} data-id="element-5" />
        <Route path="/pdp" element={<ProductDetail data-id="element-8" />} data-id="element-7" />
        <Route path="/checkout" element={<Checkout data-id="element-10" />} data-id="element-9" />
      </Routes>
    </BrowserRouter>;
}